// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"d56876d1","451":"6f3212a5","453":"6afd038a","664":"0369e7f0"}[chunkId] + ".chunk.js";
};